export const DEVTOOLS_ROOT_ID = "pg-devtools-root";
export const DEFAULT_Z_INDEX = 99999;
export const DRAG_THRESHOLD = 5;
export const LONG_PRESS_DURATION = 400;
export const LONG_PRESS_MOVE_TOLERANCE = 18;
export const HAPTIC_DURATION = 50;
export const ICON_SIZE = 40;
export const ICON_SIZE_MOBILE = 32;
export const PANEL_MAX_WIDTH = 380;
export const MOBILE_BREAKPOINT = 768;

// localStorage keys
export const STORAGE_PREFIX = "pg-devtools-";
export const STORAGE_POSITION = `${STORAGE_PREFIX}position`;
export const STORAGE_OPEN = `${STORAGE_PREFIX}open`;
export const STORAGE_SECTIONS = `${STORAGE_PREFIX}sections`;

// Cookie name for forcing devtools via cookie/URL param
export const DEVTOOLS_FORCE_COOKIE = "pg-devtools-force";

// Sensitive env var patterns
export const SENSITIVE_PATTERNS = ["KEY", "SECRET", "TOKEN", "PASSWORD", "DEPLOYMENT_KEY"];
export const DEVTOOLS_ROOT_ID = "pg-devtools-root";
export const DEFAULT_Z_INDEX = 99999;
export const DRAG_THRESHOLD = 5;
export const LONG_PRESS_DURATION = 400;
export const LONG_PRESS_MOVE_TOLERANCE = 18;
export const HAPTIC_DURATION = 50;
export const ICON_SIZE = 40;
export const ICON_SIZE_MOBILE = 32;
export const PANEL_MAX_WIDTH = 380;
export const MOBILE_BREAKPOINT = 768;

// localStorage keys
export const STORAGE_PREFIX = "pg-devtools-";
export const STORAGE_POSITION = `${STORAGE_PREFIX}position`;
export const STORAGE_OPEN = `${STORAGE_PREFIX}open`;
export const STORAGE_SECTIONS = `${STORAGE_PREFIX}sections`;

// Cookie name for forcing devtools via cookie/URL param
export const DEVTOOLS_FORCE_COOKIE = "pg-devtools-force";

// Sensitive env var patterns
export const SENSITIVE_PATTERNS = ["KEY", "SECRET", "TOKEN", "PASSWORD", "DEPLOYMENT_KEY"];
